<script lang="ts">
    import {goto} from '$app/navigation';

    interface Props {
        word: string
        english: string
        sentence: string
        t: string
        id: string
    }

    let {
        word,
        english,
        sentence,
        t,
        id
    }: Props = $props()

    function handleNavigate() {
        goto(`/browse/${id}`)
    }
</script>

<div class="row">
    <div>
        <span class="german-verb">{word}</span> -
        <span class="english-verb">{english}</span>
    </div>
    <div>
        {sentence}
    </div>
    <div class="english-sentence">
        {t}
    </div>
    <button class="dictionary-link"
            onclick={handleNavigate}
    >
        See dictionary entry »
    </button>
</div>

<style>
    .row {
        display: grid;
        justify-items: flex-start;
        gap: .2rem;
        /*border: 1px solid teal;*/
    }

    .row > div:first-of-type {
        margin-bottom: .4rem;
    }

    .dictionary-link {
        margin: .2rem 0 0 0;
        font-size: .9rem;
        background: none;
        padding: 0;
        color: var(--color-Verb);
    }

    .german-verb {
        font-weight: var(--font-emph);
        font-size: 1.05rem;
    }

    .english-verb,
    .english-sentence {
        font-style: italic;
        color: var(--color-secondary);
    }
</style>